"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useViewDataTable = useViewDataTable;
const DataTable_1 = require("@juvare/common-data-table-ui/DataTable");
const FiltersBar_1 = require("@juvare/common-data-table-ui/FiltersBar");
const react_1 = __importDefault(require("react"));
const useViewBackendDataProvider_1 = require("./useViewBackendDataProvider");
function useViewDataTable(config, { useDataTableFunction = DataTable_1.useDataTableUsingState, ...otherParams }) {
    const result = useDataTableFunction({
        useDataProvider: (0, useViewBackendDataProvider_1.useViewBackendDataProvider)(config.viewName, config.mapViewFilterData),
        defaultSortColumnKey: config.defaultSortColumnKey,
        ...otherParams,
    });
    return {
        ...result,
        dataTableProps: {
            ...result.dataTableProps,
            title: config.title,
            columns: config.columns,
            filtersBar: react_1.default.createElement(FiltersBar_1.FiltersBar, { ...result.filtersBarProps, config: config.filterConfig }),
            tableSx: config.tableSx,
        },
    };
}
